import {
  getAvailableServiceSlugs,
  getSanitySlugs,
} from "../router/dynamic-route-helpers.js";

export const routes = [
  {
    path: "/",
    name: "LandingPage",
    component: () => import("../views/LandingPage.vue"),
    meta: {
      sitemap: {
        lastmod: "December 19, 2025",
        priority: 1.0,
      },
    },
  },
  {
    path: "/benzinske-stanice",
    name: "GasStations",
    component: () => import("../views/GasStations.vue"),
    meta: {
      sitemap: {
        lastmod: "December 19, 2025",
        priority: 0.8,
      },
    },
  },
  {
    path: "/benzinske-stanice/:serviceID",
    name: "ServiceGasStations",
    component: () => import("../views/GasStations.vue"),
    meta: {
      sitemap: {
        lastmod: "December 19, 2025",
        priority: 0.8,
        slugs: async () => await getAvailableServiceSlugs(),
      },
    },
  },
  {
    path: "/najnovije-vesti/:slug",
    name: "SingleBlog",
    component: () => import("../views/SingleBlog.vue"),
    meta: {
      sitemap: {
        lastmod: "February 18, 2026",
        priority: 0.8,
        slugs: async () =>
          await getSanitySlugs(
            '*[_type == "post"] | order(publishedAt desc)',
            0.6
          ),
      },
    },
  },
  {
    path: "/lion-expert/proizvodi",
    name: "ProductsPage",
    component: () => import("../views/ProductsPage.vue"),
    meta: {
      sitemap: {
        lastmod: "February 18, 2026",
        priority: 0.7,
      },
    },
  },
  {
    path: "/lion-expert/proizvodi/:slug",
    name: "SingleProduct",
    component: () => import("../views/SingleProduct.vue"),
    meta: {
      sitemap: {
        lastmod: "February 18, 2026",
        priority: 0.7,
        slugs: async () =>
          await getSanitySlugs(
            '*[_type == "products"] | order(title desc)',
            0.7,
            "monthly"
          ),
      },
    },
  },
  {
    path: "/otvorene-pozicije",
    name: "OpenPositions",
    component: () => import("../views/OpenPositions.vue"),
    meta: {
      sitemap: {
        lastmod: "February 18, 2026",
        priority: 0.6,
      },
    },
  },
  {
    path: "/otvorene-pozicije/:slug",
    name: "SingleJob",
    component: () => import("../views/SingleJob.vue"),
    meta: {
      sitemap: {
        lastmod: "December 12, 2025",
        priority: 0.6,
        slugs: async () =>
          await getSanitySlugs(
            '*[_type == "carriers"] | order(orderNumber)',
            0.6,
            "monthly"
          ),
      },
    },
  },
  {
    path: "/zastita-podataka",
    name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
    meta: {
      sitemap: {
        priority: 0.3,
      },
    },
  },
  {
    path: "/euro-petrol-klub",
    name: "EPKlub",
    component: () => import("../views/EPKlub.vue"),
    meta: {
      sitemap: {
        lastmod: "December 12, 2025",
        priority: 0.7,
      },
    },
  },
  {
    path: "/pravila-i-uslovi-koriscenja",
    name: "AboutCookies",
    component: () => import("../views/AboutCookies.vue"),
    meta: {
      sitemap: {
        priority: 0.3,
      },
    },
  },
  {
    path: "/kontakt-informacije",
    name: "ContactInformations",
    component: () => import("../views/ContactInformations.vue"),
    meta: {
      sitemap: {
        priority: 0.7,
      },
    },
  },
  {
    path: "/usluge",
    name: "Services",
    component: () => import("../views/Services.vue"),
    meta: {
      sitemap: {
        lastmod: "December 12, 2025",
        priority: 0.7,
      },
    },
  },
  {
    path: "/politika-kvaliteta",
    name: "QualityPolicy",
    component: () => import("../views/QualityPolicy.vue"),
    meta: {
      sitemap: {
        priority: 0.4,
      },
    },
  },
  {
    path: "/pravila-i-uslovi-koriscenja-ep-klub-kartica",
    name: "AboutEPClubCard",
    component: () => import("../views/AboutEPClubCard.vue"),
    meta: {
      sitemap: {
        lastmod: "December 12, 2025",
        priority: 0.7,
      },
    },
  },
  {
    path: "/euro-petrol-aplikacija",
    name: "ApplicationPage",
    component: () => import("../views/ApplicationPage.vue"),
    meta: {
      sitemap: {
        lastmod: "June 17, 2026",
        priority: 0.9,
      },
    },
  }
];
